import { render, staticRenderFns } from "./pgaPro.vue?vue&type=template&id=31c40546&scoped=true"
import script from "./pgaPro.vue?vue&type=script&lang=js"
export * from "./pgaPro.vue?vue&type=script&lang=js"
import style0 from "./pgaPro.vue?vue&type=style&index=0&id=31c40546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c40546",
  null
  
)

export default component.exports